var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex pa-2"},[_c('div',{staticClass:"oderon-col-4 pa-2"},[_c('Sidebar')],1),_c('div',{staticClass:"oderon-col-8 pa-2"},[_c('ResumoCentrosDeCusto')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }